/**
 * Vedic Gemstone & Rudraksha Finder Quiz
 * JavaScript functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  // Elements
  const quizStep1 = document.getElementById('quiz-step-content-1');
  const quizStep2 = document.getElementById('quiz-step-content-2');
  const quizStep3 = document.getElementById('quiz-step-content-3');
  const quizProgressStep1 = document.getElementById('quiz-step-1');
  const quizProgressStep2 = document.getElementById('quiz-step-2');
  const quizProgressStep3 = document.getElementById('quiz-step-3');
  const quizLoading = document.getElementById('quiz-loading');
  const quizResults = document.getElementById('quiz-results');
  
  // Form fields - declare early
  const quizDob = document.getElementById('quiz-dob');
  

  
  // Professional DOB input formatting with enhanced UX
  if (quizDob) {
    let isBackspacing = false;
    
    // Handle keydown for backspace detection
    quizDob.addEventListener('keydown', function(e) {
      isBackspacing = e.key === 'Backspace' || e.key === 'Delete';
    });
    
    // Main input formatting logic
    quizDob.addEventListener('input', function(e) {
      let input = e.target;
      let value = input.value;
      
      // Handle backspace - if user is deleting, allow natural deletion
      if (isBackspacing) {
        // Don't reformat on backspace, just ensure only digits and slashes remain
        let cleanValue = value.replace(/[^0-9\/]/g, '');
        input.value = cleanValue;
        return;
      }
      
      // Remove all non-digits
      let digitsOnly = value.replace(/\D/g, '');
      
      // Limit to 8 digits
      if (digitsOnly.length > 8) {
        digitsOnly = digitsOnly.substring(0, 8);
      }
      
      // Format the value
      let formattedValue = '';
      
      if (digitsOnly.length > 0) {
        // Add day (first 2 digits)
        formattedValue += digitsOnly.substring(0, 2);
        
        // Add slash after 2nd digit
        if (digitsOnly.length >= 2) {
          formattedValue += '/';
        }
        
        // Add month (next 2 digits)
        if (digitsOnly.length > 2) {
          formattedValue += digitsOnly.substring(2, 4);
        }
        
        // Add slash after 4th digit
        if (digitsOnly.length >= 4) {
          formattedValue += '/';
        }
        
        // Add year (remaining digits)
        if (digitsOnly.length > 4) {
          formattedValue += digitsOnly.substring(4, 8);
        }
      }
      
      // Update input value
      input.value = formattedValue;
      
      // Always keep cursor at the end
      setTimeout(() => {
        input.setSelectionRange(formattedValue.length, formattedValue.length);
      }, 0);
    });
    
    // Enhanced keypress validation
    quizDob.addEventListener('keypress', function(e) {
      // Allow control keys
      if (e.ctrlKey || e.metaKey || e.altKey) {
        return;
      }
      
      // Allow navigation keys
      if (['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(e.key)) {
        return;
      }
      
      // Only allow digits
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
        return;
      }
      
      // Check if we've reached the digit limit
      const currentDigits = e.target.value.replace(/\D/g, '');
      if (currentDigits.length >= 8) {
        e.preventDefault();
      }
    });
    
    // Handle paste events
    quizDob.addEventListener('paste', function(e) {
      e.preventDefault();
      let pastedData = (e.clipboardData || window.clipboardData).getData('text');
      let digitsOnly = pastedData.replace(/\D/g, '').substring(0, 8);
      
      if (digitsOnly.length > 0) {
        // Trigger input event to format the pasted data
        e.target.value = digitsOnly;
        e.target.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }

  // Form fields
  const quizFirstName = document.getElementById('quiz-first-name');
  const quizLastName = document.getElementById('quiz-last-name');
  const quizFirstNameError = document.getElementById('quiz-first-name-error');
  const quizLastNameError = document.getElementById('quiz-last-name-error');
  const quizDobError = document.getElementById('quiz-dob-error');
  const quizChallengeError = document.getElementById('quiz-challenge-error');
  const quizEnhanceError = document.getElementById('quiz-enhance-error');
  
  // Buttons
  const quizNextStep1 = document.getElementById('quiz-next-step-1');
  const quizPrevStep2 = document.getElementById('quiz-prev-step-2');
  const quizNextStep2 = document.getElementById('quiz-next-step-2');
  const quizPrevStep3 = document.getElementById('quiz-prev-step-3');
  const quizSubmit = document.getElementById('quiz-submit');
  const quizCopyCoupon = document.getElementById('quiz-copy-coupon');
  const quizShareReport = document.getElementById('quiz-share-report');
  const quizStartOver = document.getElementById('quiz-start-over');

  // Result elements
  const quizResultName = document.getElementById('quiz-result-name');
  const quizRulingNumber = document.getElementById('quiz-ruling-number');
  const quizRulingPlanet = document.getElementById('quiz-ruling-planet');
  const quizPlanetImg = document.getElementById('quiz-planet-img');
  const quizPlanetDescription = document.getElementById('quiz-planet-description');
  const quizGemstoneName = document.getElementById('quiz-gemstone-name');
  const quizGemstoneImg = document.getElementById('quiz-gemstone-img');
  const quizGemstoneBenefits = document.getElementById('quiz-gemstone-benefits');
  const quizGemstoneLink = document.getElementById('quiz-gemstone-link');
  const quizRudrakshaMukhi = document.getElementById('quiz-rudraksha-mukhi');
  const quizRudrakshaImg = document.getElementById('quiz-rudraksha-img');
  const quizRudrakshaDescription = document.getElementById('quiz-rudraksha-description');
  const quizRudrakshaLink = document.getElementById('quiz-rudraksha-link');
  const quizChallengeResult = document.getElementById('quiz-challenge-result');
  const quizEnhanceResult = document.getElementById('quiz-enhance-result');
  const quizPracticesList = document.getElementById('quiz-practices-list');
  
  // Navigation
  if (quizNextStep1) {
    quizNextStep1.addEventListener('click', function() {
      if (validateStep1()) {
        navigateToStep(2);
      }
    });
  }
  
  if (quizPrevStep2) {
    quizPrevStep2.addEventListener('click', function() {
      navigateToStep(1);
    });
  }
  
  if (quizNextStep2) {
    quizNextStep2.addEventListener('click', function() {
      if (validateStep2()) {
        navigateToStep(3);
      }
    });
  }
  
  if (quizPrevStep3) {
    quizPrevStep3.addEventListener('click', function() {
      navigateToStep(2);
    });
  }
  
  if (quizSubmit) {
    quizSubmit.addEventListener('click', function() {
      if (validateStep3()) {
        submitQuiz();
      }
    });
  }
  
  // Copy coupon code
  if (quizCopyCoupon) {
    quizCopyCoupon.addEventListener('click', function() {
      // Try modern clipboard API first
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText('SOUL10QUIZ').then(function() {
          showToast('Code copied to clipboard!', 'success');
        }).catch(function(err) {
          // Fallback to legacy method
          copyToClipboardFallback('SOUL10QUIZ');
        });
      } else {
        // Use fallback method directly
        copyToClipboardFallback('SOUL10QUIZ');
      }
    });
  }
  
  // Fallback copy function for browsers that don't support clipboard API
  function copyToClipboardFallback(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        showToast('Code copied to clipboard!', 'success');
      } else {
        showToast('Unable to copy code. Please copy manually: SOUL10QUIZ', 'error');
      }
    } catch (err) {
      showToast('Unable to copy code. Please copy manually: SOUL10QUIZ', 'error');
    } finally {
      document.body.removeChild(textArea);
    }
  }
  
  // Custom toast notification function
  function showToast(message, type = 'info') {
    // Remove any existing toast
    const existingToast = document.querySelector('.quiz-toast');
    if (existingToast) {
      existingToast.remove();
    }
    
    // Create toast element
    const toast = document.createElement('div');
    toast.className = `quiz-toast quiz-toast-${type}`;
    toast.textContent = message;
    
    // Add styles
    toast.style.cssText = `
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: ${type === 'success' ? '#4CAF50' : type === 'error' ? '#f44336' : '#333'};
      color: white;
      padding: 12px 24px;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 500;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 10000;
      opacity: 0;
      transition: opacity 0.3s ease;
      max-width: 90%;
      text-align: center;
    `;
    
    // Add to page
    document.body.appendChild(toast);
    
    // Animate in
    setTimeout(() => {
      toast.style.opacity = '1';
    }, 10);
    
    // Remove after 3 seconds
    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 300);
    }, 3000);
  }
  
  // Share report
  if (quizShareReport) {
    quizShareReport.addEventListener('click', function() {
      showToast('Sharing feature coming soon!', 'info');
    });
  }
  
  // Start over
  if (quizStartOver) {
    quizStartOver.addEventListener('click', function() {
      resetQuiz();
    });
  }

  // Reset quiz function
  function resetQuiz() {
    // Reset all form inputs
    quizFirstName.value = '';
    quizLastName.value = '';
    quizDob.value = '';
    
    // Clear radio button selections
    const challengeRadios = document.querySelectorAll('input[name="quiz-challenge"]');
    const enhanceRadios = document.querySelectorAll('input[name="quiz-enhance"]');
    
    challengeRadios.forEach(radio => radio.checked = false);
    enhanceRadios.forEach(radio => radio.checked = false);
    
    // Clear error messages
    document.querySelectorAll('.quiz-error-message').forEach(error => error.textContent = '');
    document.querySelectorAll('.quiz-input').forEach(input => input.classList.remove('quiz-error'));
    
    // Hide results and loading
    quizResults.style.display = 'none';
    quizLoading.style.display = 'none';
    
    // Reset to step 1
    navigateToStep(1);
    
    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // Validation functions
  function validateStep1() {
    let isValid = true;
    
    // First Name validation
    if (!quizFirstName.value.trim()) {
      quizFirstNameError.textContent = 'Please enter your first name';
      quizFirstName.classList.add('quiz-error');
      isValid = false;
    } else {
      quizFirstNameError.textContent = '';
      quizFirstName.classList.remove('quiz-error');
    }
    
    // Last Name validation
    if (!quizLastName.value.trim()) {
      quizLastNameError.textContent = 'Please enter your last name';
      quizLastName.classList.add('quiz-error');
      isValid = false;
    } else {
      quizLastNameError.textContent = '';
      quizLastName.classList.remove('quiz-error');
    }
    
    // Date of Birth validation
    if (!quizDob.value.trim()) {
      quizDobError.textContent = 'Please enter your date of birth';
      quizDob.classList.add('quiz-error');
      isValid = false;
    } else if (!isValidDateFormat(quizDob.value.trim())) {
      quizDobError.textContent = 'Please enter date in DD/MM/YYYY format';
      quizDob.classList.add('quiz-error');
      isValid = false;
    } else {
      quizDobError.textContent = '';
      quizDob.classList.remove('quiz-error');
    }
    
    return isValid;
  }
  
  function validateStep2() {
    let selectedChallenge = document.querySelector('input[name="quiz-challenge"]:checked');
    
    if (!selectedChallenge) {
      quizChallengeError.textContent = 'Please select a challenge';
      return false;
    } else {
      quizChallengeError.textContent = '';
      return true;
    }
  }
  
  function validateStep3() {
    let selectedEnhance = document.querySelector('input[name="quiz-enhance"]:checked');
    
    if (!selectedEnhance) {
      quizEnhanceError.textContent = 'Please select an area to enhance';
      return false;
    } else {
      quizEnhanceError.textContent = '';
      return true;
    }
  }

  // Navigation function
  function navigateToStep(step) {
    // Hide all steps
    quizStep1.classList.remove('quiz-active');
    quizStep2.classList.remove('quiz-active');
    quizStep3.classList.remove('quiz-active');
    quizProgressStep1.classList.remove('quiz-active');
    quizProgressStep2.classList.remove('quiz-active');
    quizProgressStep3.classList.remove('quiz-active');
    
    // Show selected step
    if (step === 1) {
      quizStep1.classList.add('quiz-active');
      quizProgressStep1.classList.add('quiz-active');
    } else if (step === 2) {
      quizStep2.classList.add('quiz-active');
      quizProgressStep2.classList.add('quiz-active');
    } else if (step === 3) {
      quizStep3.classList.add('quiz-active');
      quizProgressStep3.classList.add('quiz-active');
    }
    
    // Smooth scroll to top of form
    document.querySelector('.quiz-form-container').scrollIntoView({ behavior: 'smooth' });
  }

  // Submit quiz function
  function submitQuiz() {
    // Show loading spinner
    quizStep3.classList.remove('quiz-active');
    quizLoading.style.display = 'flex';
    
    // Get user inputs
    const firstName = quizFirstName.value.trim();
    const lastName = quizLastName.value.trim();
    const dob = parseDate(quizDob.value.trim());
    const selectedChallenge = document.querySelector('input[name="quiz-challenge"]:checked').value;
    const selectedEnhance = document.querySelector('input[name="quiz-enhance"]:checked').value;
    
    // Calculate ruling number (sum day of birth to a single digit)
    let day = dob.getDate();
    let rulingNumber = calculateRulingNumber(day);
    
    // Get recommendations
    const planet = getPlanetByNumber(rulingNumber);
    const gemstone = getGemstoneRecommendation(selectedEnhance, selectedChallenge);
    const mukhi = getRudrakshaMukhi(rulingNumber);
    
    // Simulate API call delay
    setTimeout(function() {
      // Populate results
      populateResults(firstName, lastName, rulingNumber, planet, gemstone, mukhi, selectedChallenge, selectedEnhance);
      
      // Hide loading and show results
      quizLoading.style.display = 'none';
      quizResults.style.display = 'block';
      
      // Scroll to results
      quizResults.scrollIntoView({ behavior: 'smooth' });
      
      // Send data to server (placeholder for actual API integration)
      sendDataToServer(firstName, lastName, dob, selectedChallenge, selectedEnhance, rulingNumber, planet, gemstone, mukhi);
    }, 2000);
  }
  
  // Validate date format DD/MM/YYYY
  function isValidDateFormat(dateString) {
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
    if (!regex.test(dateString)) {
      return false;
    }
    
    const [day, month, year] = dateString.split('/').map(num => parseInt(num));
    const date = new Date(year, month - 1, day);
    const currentYear = new Date().getFullYear();
    
    // Check if date is valid and year is reasonable (between 1900 and current year)
    return date.getFullYear() === year && 
           date.getMonth() === month - 1 && 
           date.getDate() === day &&
           year >= 1900 && year <= currentYear;
  }
  
  // Parse DD/MM/YYYY format to Date object
  function parseDate(dateString) {
    const [day, month, year] = dateString.split('/').map(num => parseInt(num));
    return new Date(year, month - 1, day);
  }
  
  // Calculate ruling number
  function calculateRulingNumber(day) {
    // Sum digits until we get a single digit
    let sum = day;
    while (sum > 9) {
      sum = String(sum).split('').reduce((a, b) => parseInt(a) + parseInt(b), 0);
    }
    return sum;
  }
  
  // Get planet by ruling number
  function getPlanetByNumber(number) {
    const planets = {
      1: {
        name: 'Sun',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Sun.png?v=1757310091',
        description: 'The Sun represents leadership, authority, and vitality. It enhances confidence and brings clarity to your path.'
      },
      2: {
        name: 'Moon',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/MOON.png?v=1757310090',
        description: 'The Moon governs emotions, intuition, and nurturing energy. It helps balance emotions and enhances sensitivity.'
      },
      3: {
        name: 'Jupiter',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/jupiter.png?v=1757310091',
        description: 'Jupiter brings expansion, wisdom, and abundance. It helps with spiritual growth and broadens perspectives.'
      },
      4: {
        name: 'Rahu',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Rahu.png?v=1757310091',
        description: 'Rahu represents transformation, illusion, and desire. It can bring sudden changes and unconventional wisdom.'
      },
      5: {
        name: 'Mercury',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/mercury.png?v=1757310091',
        description: 'Mercury governs communication, intellect, and adaptability. It enhances mental clarity and expression.'
      },
      6: {
        name: 'Venus',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Venus.png?v=1757310091',
        description: 'Venus rules love, beauty, and harmony. It brings balance to relationships and enhances creativity.'
      },
      7: {
        name: 'Ketu',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Ketu.png?v=1757310091',
        description: 'Ketu represents spirituality, liberation, and detachment. It helps with spiritual insights and letting go.'
      },
      8: {
        name: 'Saturn',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Satrun.png?v=1757310091',
        description: 'Saturn governs discipline, responsibility, and karmic lessons. It brings structure and enduring strength.'
      },
      9: {
        name: 'Mars',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Mars.png?v=1757310091',
        description: 'Mars represents energy, action, and courage. It enhances determination and helps overcome challenges.'
      }
    };
    
    return planets[number] || planets[1]; // Default to Sun if invalid
  }
  
  // Get gemstone recommendation
  function getGemstoneRecommendation(enhance, challenge) {
    const gemstones = {
      'career-finance': {
        name: 'Pyrite',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Pyrite_9eb91669-3949-4c99-9d7a-e46d386fb7cf.webp?v=1757310212',
        benefits: 'Known as "Fool\'s Gold," Pyrite attracts abundance, wealth, and success in business ventures. It enhances willpower and manifestation abilities.',
        link: 'https://soultheory.in/collections/pyrite-1'
      },
      'love-relationships': {
        name: 'Rose Quartz',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Rose_Quartz_772ff616-728b-4284-a5e4-6633f571c243.webp?v=1757310212',
        benefits: 'The stone of unconditional love, Rose Quartz opens the heart chakra and attracts loving relationships. It promotes compassion, healing, and inner peace.',
        link: 'https://soultheory.in/collections/rose-quartz-1'
      },
      'health-wellness': {
        name: 'Malachite',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Malachite_5938d1f0-fefe-4a26-9b84-74d3e574470d.avif?v=1757310212',
        benefits: 'A powerful healing stone, Malachite detoxifies the body and strengthens the immune system. It balances energy and promotes physical wellness.',
        link: 'https://soultheory.in/collections/malachite'
      },
      'spiritual-growth': {
        name: 'Amethyst',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Amethyst_0fd01445-179e-4760-9c18-8ffb648600c7.avif?v=1757310212',
        benefits: 'The ultimate spiritual stone, Amethyst enhances meditation, intuition, and connection to higher realms. It brings clarity and spiritual wisdom.',
        link: 'https://soultheory.in/collections/amethyst'
      },
      'protection-grounding': {
        name: 'Hematite',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Hematite_29a82121-10ce-4201-81f5-86d8fb269247.webp?v=1757310212',
        benefits: 'A powerful grounding stone, Hematite shields against negative energy and electromagnetic radiation. It promotes stability and courage.',
        link: 'https://soultheory.in/collections/hematite'
      },
      'work-stress': {
        name: 'Fluorite',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Fluorite_40bd4ec3-a2fc-41f7-82bf-5d9582ed715a.webp?v=1757310212',
        benefits: 'Known as the "Genius Stone," Fluorite reduces stress, enhances focus, and improves decision-making. It brings order to chaos and mental clarity.',
        link: 'https://soultheory.in/collections/fluorite'
      },
      'financial': {
        name: 'Citrine',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Citrine_c3c00a30-9165-48c3-969d-ca916176300f.avif?v=1757310212',
        benefits: 'Known as the "Merchant\'s Stone," Citrine attracts wealth, abundance, and prosperity. It promotes confidence and positive energy in financial matters.',
        link: 'https://soultheory.in/collections/citrine'
      },
      'relationship': {
        name: 'Amazonite',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Amazonite_cd549e2b-251a-4384-af31-bbab362a08f2.webp?v=1757310212',
        benefits: 'The stone of harmony, Amazonite soothes emotional trauma and resolves conflicts. It enhances communication and brings balance to relationships.',
        link: 'https://soultheory.in/collections/amazonite'
      },
      'focus': {
        name: 'Labradorite',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Labradorite_9d28311c-0608-4ac9-893c-b756d01d878c.avif?v=1757310212',
        benefits: 'The stone of transformation, Labradorite enhances mental clarity, focus, and intuition. It dispels illusions and strengthens inner awareness.',
        link: 'https://soultheory.in/collections/labradorite'
      },
      'health': {
        name: 'Clear Quartz',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/Clear_Quartz_f4e77191-4e60-4ea6-88ca-efecbfc5c375.webp?v=1757310212',
        benefits: 'The master healer, Clear Quartz amplifies energy and intention. It balances all chakras and enhances the body\'s natural healing abilities.',
        link: 'https://soultheory.in/collections/clear-quartz'
      }
    };
    
    // First try to match by enhance area, then by challenge, then default to Clear Quartz
    return gemstones[enhance] || gemstones[challenge] || gemstones['health'];
  }
  
  // Get Rudraksha Mukhi by ruling number
  function getRudrakshaMukhi(number) {
    const rudrakshas = {
      1: {
        mukhi: '1',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/1_mukhi.png?v=1757310369',
        description: 'One Mukhi Rudraksha represents Lord Shiva and enhances focus, concentration, and spiritual awakening. It brings cosmic unity and divine protection.',
        link: 'https://soultheory.in/products/natural-1-mukhi-nepali-rudraksha-ek-mukhi?_pos=4&_sid=702a6393f&_ss=r'
      },
      2: {
        mukhi: '2',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/2_mukhi.png?v=1757310368',
        description: 'Two Mukhi Rudraksha represents the divine union of Shiva-Shakti. It brings harmony to relationships and balances dual aspects of life.',
        link: 'https://soultheory.in/products/natural-2-mukhi-nepali-rudraksha-dho-mukhi?_pos=12&_sid=702a6393f&_ss=r'
      },
      3: {
        mukhi: '5',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/5_mukhi.png?v=1757310368',
        description: 'Five Mukhi Rudraksha represents Lord Shiva\'s five faces. It bestows health, wealth, and spiritual growth while removing negative energies.',
        link: 'https://soultheory.in/products/natural-5-mukhi-nepali-rudraksha-chaar-mukhi?_pos=10&_sid=702a6393f&_ss=r'
      },
      4: {
        mukhi: '8',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/8_mukhi.png?v=1757310369',
        description: 'Eight Mukhi Rudraksha is associated with Lord Ganesha, the remover of obstacles. It brings success and removes barriers in your path.',
        link: 'https://soultheory.in/products/natural-8-mukhi-nepali-rudraksha-aath-mukhi?_pos=16&_sid=702a6393f&_ss=r'
      },
      5: {
        mukhi: '4',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/4_mukhi.png?v=1757310368',
        description: 'Four Mukhi Rudraksha represents Lord Brahma, the creator. It enhances intellect, knowledge, and creativity while promoting mental clarity.',
        link: 'https://soultheory.in/products/natural-4-mukhi-nepali-rudraksha-chaar-mukhi?_pos=7&_sid=702a6393f&_ss=r'
      },
      6: {
        mukhi: '6',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/6_mukhi.png?v=1757310368',
        description: 'Six Mukhi Rudraksha represents Lord Kartikeya. It brings success in education, increases knowledge, and enhances communication skills.',
        link: 'https://soultheory.in/products/natural-6-mukhi-nepali-rudraksha-chhey-mukhi?_pos=11&_sid=702a6393f&_ss=r'
      },
      7: {
        mukhi: '9',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/9_mukhi.png?v=1757310368',
        description: 'Nine Mukhi Rudraksha represents Goddess Durga. It provides courage, strength, and protection from negative energies and malefic planets.',
        link: 'https://soultheory.in/products/natural-9-mukhi-nepali-rudraksha-nau-mukhi?_pos=8&_sid=702a6393f&_ss=r'
      },
      8: {
        mukhi: '7',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/7_mukhi.png?v=1757310369',
        description: 'Seven Mukhi Rudraksha represents Goddess Mahalakshmi. It brings wealth, prosperity, and good fortune while removing financial obstacles.',
        link: 'https://soultheory.in/products/natural-7-mukhi-nepali-rudraksha-saat-mukhi?_pos=1&_sid=0f2e8d33a&_ss=r'
      },
      9: {
        mukhi: '3',
        image: 'https://cdn.shopify.com/s/files/1/0833/4478/5725/files/3_mukhi.png?v=1757310368',
        description: 'Three Mukhi Rudraksha represents Lord Agni (Fire God). It increases willpower, courage, and energy while burning away negative karma.',
        link: 'https://soultheory.in/products/natural-3-mukhi-nepali-rudraksha-teen-mukhi?_pos=6&_sid=0f2e8d33a&_ss=r'
      }
    };
    
    return rudrakshas[number] || rudrakshas[1]; // Default to 1 Mukhi if invalid
  }
  
  // Populate results in the UI
  function populateResults(firstName, lastName, rulingNumber, planet, gemstone, mukhi, challengeValue, enhanceValue) {
    // Display name
    quizResultName.textContent = firstName + ' ' + lastName;
    
    // Ruling number and planet
    quizRulingNumber.textContent = rulingNumber;
    quizRulingPlanet.textContent = planet.name;
    quizPlanetImg.src = planet.image;
    quizPlanetImg.alt = planet.name;
    quizPlanetDescription.textContent = planet.description;
    
    // Gemstone
    quizGemstoneName.textContent = gemstone.name;
    quizGemstoneImg.src = gemstone.image;
    quizGemstoneImg.alt = gemstone.name;
    quizGemstoneBenefits.textContent = gemstone.benefits;
    quizGemstoneLink.href = gemstone.link;
    
    // Rudraksha
    quizRudrakshaMukhi.textContent = mukhi.mukhi;
    quizRudrakshaImg.src = mukhi.image;
    quizRudrakshaImg.alt = mukhi.mukhi + ' Mukhi Rudraksha';
    quizRudrakshaDescription.textContent = mukhi.description;
    quizRudrakshaLink.href = mukhi.link;
    
    // User inputs
    const challengeLabels = {
      'work-stress': 'Work-related stress or burnout',
      'financial': 'Financial worries or instability',
      'relationship': 'Relationship conflicts or loneliness',
      'focus': 'Lack of focus or clarity',
      'health': 'Health concerns or low energy'
    };
    
    const enhanceLabels = {
      'career-finance': 'Career/Finance',
      'love-relationships': 'Love/Relationships',
      'health-wellness': 'Health/Wellness',
      'spiritual-growth': 'Spiritual/Personal Growth',
      'protection-grounding': 'Protection/Grounding'
    };
    
    quizChallengeResult.textContent = challengeLabels[challengeValue];
    quizEnhanceResult.textContent = enhanceLabels[enhanceValue];
    
    // Practices
    const practices = [
      `Wear your ${gemstone.name} on your dominant hand to maximize its energy flow.`,
      `Meditate with your ${mukhi.mukhi} Mukhi Rudraksha for 10 minutes each morning to align with its divine energy.`,
      `Cleanse your crystals under running water or moonlight once a week to clear accumulated energies.`,
      `Recite the mantra "Om Namah Shivaya" 108 times daily while holding your Rudraksha.`,
      `Journal about your experiences with your gemstone and Rudraksha to track your spiritual growth.`
    ];
    
    quizPracticesList.innerHTML = '';
    practices.forEach(practice => {
      const li = document.createElement('li');
      li.textContent = practice;
      quizPracticesList.appendChild(li);
    });
  }
  
  // Send data to server (placeholder function)
  function sendDataToServer(firstName, lastName, dob, challenge, enhance, rulingNumber, planet, gemstone, mukhi) {
    console.log('Sending data to server...');
    
    // This would be replaced with an actual API call in production
    const data = {
      firstName: firstName,
      lastName: lastName,
      dob: dob,
      challenge: challenge,
      enhance: enhance,
      rulingNumber: rulingNumber,
      planet: planet.name,
      gemstone: gemstone.name,
      mukhi: mukhi.mukhi,
      benefits: gemstone.benefits
    };
    
    console.log('Data to send:', data);
    
    // Example fetch call (commented out as it's a placeholder)
    /*
    fetch('https://your-server-endpoint.com/submit-quiz', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    */
  }
});